import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import _ from "lodash";
import {Empty, Modal, notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {handleRequest, apiError} from "~/utils";
import {purchaseOrderApi} from "~/api";
import {
    Button,
    Loading,
    Icon
} from "~/components";
import {
    PurchaseOrderTable,
    PurchaseSearchOrderBar
} from "../components";
import {
    purchaseOrderActions,
    purchaseOrderErrorSelector,
    purchaseOrderFilterSelector,
    purchaseOrderItemsSelector,
    purchaseOrderLoadingSelector,
    purchaseOrderPaginationSelector
} from "../../../reduxs/PurchaseOrder/purchaseOrderSlice";

const PurchaseOrder = () =>
{
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const items = useSelector(purchaseOrderItemsSelector);
    const loading = useSelector(purchaseOrderLoadingSelector);
    const error = useSelector(purchaseOrderErrorSelector);
    const pagination = useSelector(purchaseOrderPaginationSelector);
    const filter = useSelector(purchaseOrderFilterSelector);

    const [itemEdit, setItemEdit] = useState({});

    //Model
    const [openModal, setOpenModal] = useState({
        delete: false,
    });

    const eventHandlers =
    {
        openModal: useCallback((modal) =>
        {
            setOpenModal(prev => ({ ...prev, [modal]: true }));
        }, []),

        closeModal: useCallback((modal) =>
        {
            setOpenModal(prev => ({ ...prev, [modal]: false }));
        }, []),

        load: useCallback(() =>
        {
            dispatch(purchaseOrderActions.fetchData(filter));
        }, [dispatch, filter]),

        paginationChange: (page) =>
        {
            dispatch(purchaseOrderActions.setFilter({...filter, page }));
        },

        filterChange: (key, value) =>
        {
            const newFilter = {
                ...filter,
                [key]: value,
                page: 1
            };
            dispatch(purchaseOrderActions.setFilter(newFilter));
        },

        edit: (record) => {
            navigate(`/purchase-order/${record.id}/edit`);
        },

        //Delete
        delete: async () =>
        {
            if (!itemEdit?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin phiếu nhập hàng để xóa'});
                return;
            }

            let [error, response] = await handleRequest(purchaseOrderApi.delete(itemEdit.id));

            if(!apiError(`Xóa phiếu nhập hàng thất bại`, error, response))
            {
                notification.success({message: 'Thành công', description: `Xóa phiếu nhập hàng thành công`});

                dispatch(purchaseOrderActions.delete(itemEdit.id));

                eventHandlers.closeModal('delete')
            }
        }
    }

    //Load data
    useEffect(() =>
    {
        let isMounted = true;
        if (isMounted) eventHandlers.load();
        return () => { isMounted = false };
    }, [filter]);

    return (
        <>
            <ActionBar title="Phiếu nhập hàng">
                <Button background blue onClick={() => navigate('/purchase-order/add')}>
                    Thêm phiếu nhập hàng
                </Button>
                <Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content p-2">
                    {loading && <Loading />}
                    {<PurchaseSearchOrderBar filter={filter} onSearchChange={eventHandlers.search} onChange={eventHandlers.filterChange} />}
                    {_.isEmpty(items) && <Empty description="Chưa có phiếu nhập hàng nào" />}
                    {!_.isEmpty(items) && <PurchaseOrderTable
                        items={items}
                        pagination={pagination}
                        onPaginationChange={eventHandlers.paginationChange}
                        onEdit={eventHandlers.edit}
                        onDelete={(record) => {
                            setItemEdit(record);
                            eventHandlers.openModal('delete');
                        }}
                    />}
                </div>
                {
                    itemEdit?.id && <Modal
                        title="Xóa phiếu nhập hàng"
                        open={openModal.delete}
                        onOk={eventHandlers.delete}
                        okType={'danger'}
                        onCancel={() => {eventHandlers.closeModal('delete')}}
                    >
                        <p>Bạn muốn xóa phiếu nhập hàng <b>{itemEdit?.code}</b>?</p>
                    </Modal>
                }
            </div>
        </>
    );
};

export default PurchaseOrder;
